import Button from 'components/_UI/Button'
import Fieldset from 'components/_UI/Fieldset'
import Loader from 'components/_UI/Loader'
import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import fieldValidations from 'helpers/fieldValidations'
import React, { useState } from 'react'
import { UserPlus } from 'lucide-react'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'
import { FullyCentered, HorizontalCenter } from 'styled/alignment/Center'
import { Column } from 'styled/alignment/Column'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'
import { panelAccent, panelAccentAlpha } from 'theme/panelAccent'
import teamsApi from 'api/requests/teams'

export default function TeamMemberModal({ visible, teamId, onClose, onSuccess }) {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);

    async function onSubmit({ email }) {
        setErrorMessage(false);
        setLoading(true);

        try {
            await teamsApi.addMember(teamId, { guest_email: email });
            onSuccess();
        } catch ({ response }) {
            setErrorMessage(response?.data?.message)
        } finally {
            setLoading(false);
        }
    }

    return (
        <Modal isOpen={visible} closeButton={true} onClose={onClose} size='medium'>
            <Container onSubmit={handleSubmit(onSubmit)}>
                <ModalHeader>
                    <IconCircle>
                        <UserPlus size={20} color={panelAccent(colors.secondaryPurple)} />
                    </IconCircle>
                    <HeaderTitle>Adicionar membro</HeaderTitle>
                </ModalHeader>

                <Column marginTop={'20px'}>
                    <Text color={colors.night}>
                        O usuário deve possuir uma conta Whizr registrada com o e-mail informado. Ele passa a ter exatamente as permissões definidas para esta equipe.
                    </Text>

                    <Fieldset
                        marginTop='10px'
                        label='E-mail do membro'
                        register={register}
                        name='email'
                        validations={fieldValidations.email()}
                    />

                    {
                        !errorMessage && errors.email && (
                            <HorizontalCenter>
                                <Text color={colors.danger}>
                                    {errors.email?.message}
                                </Text>
                            </HorizontalCenter>
                        )
                    }

                    {
                        errorMessage && !errors.email &&
                        (
                            <HorizontalCenter >
                                <Text color={colors.danger}>
                                    {errorMessage}
                                </Text>
                            </HorizontalCenter>
                        )
                    }
                </Column>

                {
                    loading ? (
                        <FullyCentered height='60px'>
                            <Loader />
                        </FullyCentered>
                    ) : (
                        <ButtonsContainer>
                            <Button
                                variant={'light'}
                                category='roundedBorded'
                                onClick={onClose}
                            >
                                Cancelar
                            </Button>

                            <Button
                                variant={'lightBlue'}
                                category='roundedBorded'
                                type={'submit'}
                            >
                                Adicionar membro
                            </Button>
                        </ButtonsContainer>
                    )
                }
            </Container>
        </Modal >
    )
}


const Container = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
    text-align: left;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
`;

const ButtonsContainer = styled(Column)`
    margin-top: 20px;

    @media screen and (min-width: ${breakpoints.md}) {
        margin-top: 40px;
        flex-direction: row;

        button:first-child {
            margin-right: 16px;
        }
    }
`;

const ModalHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

const IconCircle = styled.div`
    width: 42px;
    height: 42px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${panelAccentAlpha(colors.occasionalPurple, '15')};
    flex-shrink: 0;
`;

const HeaderTitle = styled.h2`
    font-size: 20px;
    font-weight: 600;
    color: ${colors.nightDark};
    margin: 0;
`;
